export default __webpack_public_path__ + "static/Metal_Ocean_Platform-566589a1cff3a1a4b7f3df5c41348fed.png";